import { BitacoraRutas, GetResponseBody, GetHeaderRequest } from './RutasConfig';

export const Registrar_Bitacora_Credomatic_Request = async (pToken, pBitacora) => {
    const result = await fetch(BitacoraRutas.Registrar_Bitacora_Credomatic, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(pBitacora)
    });
    return await GetResponseBody(result);
};

export const Actualizar_Bitacora_Credomatic_Request = async (pToken, pBitacora) => {
    const result = await fetch(BitacoraRutas.Actualizar_Bitacora_Credomatic, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(pBitacora)
    });
    return await GetResponseBody(result);
};